export default "__VITE_PUBLIC_ASSET__87b2e175__"